<template>
  <div class="flex-container">
    <div class="flex-item_left">
      <patient-input />
    </div>

    <div class="flex-item_right">
      <patient-outcome />
    </div>
  </div>
</template>

<script>
import PatientInput from "@/components/PatientInput";
import PatientOutcome from "@/components/PatientOutcome";

export default {
  name: "Calculator",
  components: {
    PatientInput,
    PatientOutcome
  },
  mounted() {
    window.analytics.page("Calculator");
  }
};
</script>

<style lang="scss">
body {
  margin: 0px;
  font-family: DM Sans;
}

/* Variables */
$sideBarWidth: 400px;
$navbarHeight: 80px;
// $navbarColor: #2e68bd;
$navbarColor: #05122d;

.flex-container {
  display: flex;
  width: 100%;
  margin: -40px;
  // padding-top: $navbarHeight;
}
.flex-item_left {
  width: $sideBarWidth;
  // height: calc(100vh - #{$navbarHeight});
  // overflow: auto;
}
.flex-item_right {
  flex: 1;
}

.main-container {
  height: 100vh;
  .ui.menu {
    min-height: 0px;
  }
  .fixed-sidebar {
    width: $sideBarWidth !important;
  }
  .ui.wide.left.sidebar {
    width: $sideBarWidth !important;
  }
  .ui.visible.wide.left.sidebar ~ .pusher {
    transform: translate3d($sideBarWidth, 0, 0);
  }
  .pushable {
    height: calc(100vh - #{$navbarHeight});
    .pusher {
      width: calc(100vw - #{$sideBarWidth});
      height: 100%;
      overflow: scroll;
      transition: width 1s;
      &.full-width {
        width: 100%;
      }
    }
  }

  .ui.menu.navbar {
    height: $navbarHeight;
    margin: 0px;
    background: $navbarColor;
    border: 0px;
    border-radius: 0px;
    color: #ffffff;

    // Sticky
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;

    h1 {
      display: flex;
      position: absolute;
      margin: 0px;
      top: 13px;
      left: 70px;
    }
    svg {
      margin-left: 10px;
    }
    small {
      display: flex;
      position: absolute;
      top: 50px;
      left: 70px;
    }
    .logo {
      position: absolute;
      height: 44px;
      top: 15px;
      right: 70px;
    }
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
}
</style>
